import { z } from 'zod';
import {
    CloverReadinessCheckStatus,
    CloverReadinessFailureReason,
    CloverReadinessUnverifiedReason,
    type CloverReadinessCheck,
    type CloverReadinessNotReadyCheck,
    type CloverReadinessReadyCheck,
    type CloverReadinessResult,
    type CloverReadinessUnverifiedCheck,
} from '../../../types/ipg/clover/clover-readiness.types';

export const CloverReadinessFailureReasonSchema: z.ZodType<CloverReadinessFailureReason> = z.enum([
    CloverReadinessFailureReason.UNAUTHORIZED,
    CloverReadinessFailureReason.UNAVAILABLE,
    CloverReadinessFailureReason.MALFORMED_RESPONSE,
    CloverReadinessFailureReason.TIMEOUT,
    CloverReadinessFailureReason.INACTIVE,
    CloverReadinessFailureReason.NOT_CONFIGURED,
    CloverReadinessFailureReason.UNSUPPORTED,
]);

export const CloverReadinessReadyCheckSchema: z.ZodType<CloverReadinessReadyCheck> = z
    .object({
        status: z.literal(CloverReadinessCheckStatus.READY),
    })
    .strict();

export const CloverReadinessNotReadyCheckSchema: z.ZodType<CloverReadinessNotReadyCheck> = z
    .object({
        status: z.literal(CloverReadinessCheckStatus.NOT_READY),
        reason: CloverReadinessFailureReasonSchema,
        message: z.string().trim().min(1),
    })
    .strict();

export const CloverReadinessUnverifiedReasonSchema: z.ZodType<CloverReadinessUnverifiedReason> =
    z.enum([CloverReadinessUnverifiedReason.SAFE_PROBE_UNAVAILABLE]);

export const CloverReadinessUnverifiedCheckSchema: z.ZodType<CloverReadinessUnverifiedCheck> = z
    .object({
        status: z.literal(CloverReadinessCheckStatus.UNVERIFIED),
        reason: CloverReadinessUnverifiedReasonSchema,
        message: z.string().trim().min(1),
    })
    .strict();

export const CloverReadinessCheckSchema: z.ZodType<CloverReadinessCheck> = z.union([
    CloverReadinessReadyCheckSchema,
    CloverReadinessNotReadyCheckSchema,
    CloverReadinessUnverifiedCheckSchema,
]);

export const CloverReadinessResultSchema: z.ZodType<CloverReadinessResult> = z.object({
    credential: CloverReadinessCheckSchema,
    ecommerceKey: CloverReadinessCheckSchema,
    cloudPayDevice: CloverReadinessCheckSchema,
    multiPay: CloverReadinessCheckSchema,
});
